export enum AppBrand {
  Brighterly = 'BRIGHTERLY',
  SmartestMinds = 'SMARTESTMINDS',
}
